import React from 'react';
import { Button } from './ui/button';
import { Heart, ArrowRight, Sparkles, ScrollText } from 'lucide-react';
import { siteData } from '../data/mock';

const CTASection = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-emerald-50 rounded-full blur-3xl opacity-60" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-amber-50 rounded-full blur-3xl opacity-60" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-emerald-50 border border-emerald-200 rounded-full px-5 py-2 mb-8">
          <Sparkles className="w-4 h-4 text-emerald-600" />
          <span className="text-emerald-700 font-medium text-sm">Every Donation Makes A Difference</span>
        </div>

        {/* Headline */}
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-stone-800 mb-6 leading-tight">
          Ready To Make An <span className="text-emerald-600">Impact</span>?
        </h2>

        {/* Description */}
        <p className="text-xl text-stone-600 mb-10 max-w-2xl mx-auto leading-relaxed">
          Join hundreds of supporters who believe in fair pay, better health, 
          and leadership accountability for all Jamaicans.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <div className="flex flex-col gap-3 w-full sm:w-auto">
            <Button
              asChild
              size="lg"
              className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-lg px-10 py-7 shadow-xl shadow-emerald-600/20 hover:shadow-emerald-600/30 transition-all hover:scale-105"
            >
              <a href={siteData.donateUrl} target="_blank" rel="noopener noreferrer">
                <Heart className="w-5 h-5 mr-2" />
                Donate Now
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              className="border-2 border-emerald-300 text-emerald-700 hover:bg-emerald-50 hover:border-emerald-400 font-semibold"
            >
              <a href="#petition">
                <ScrollText className="w-4 h-4 mr-2" />
                Sign Petition
              </a>
            </Button>
          </div>
          <Button
            asChild
            variant="outline"
            size="lg"
            className="border-2 border-stone-300 text-stone-700 hover:bg-stone-50 hover:border-stone-400 font-semibold text-lg px-10 py-7 transition-all"
          >
            <a href="#why-it-matters">
              Learn Our Story
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </Button>
        </div>

        {/* Trust Text */}
        <p className="mt-8 text-stone-500 text-sm">
          Secure donation via GoFundMe • 100% goes to the cause
        </p>
      </div>
    </section>
  );
};

export default CTASection;
